import PropTypes from 'prop-types';

export const buttonTypes = {
  children: PropTypes.string.isRequired,
  optionImage: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  externalLink: PropTypes.string,
  linkTo: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      optionName: PropTypes.string.isRequired
    }).isRequired
  )
};
